export type Link = {
  name: string;
  /** The `?page=` value; the URL contract, never renamed. */
  action: string;
  description: string;
  /** Menu section the tool lived under before the grouped menu. */
  previously?: string;
  url?: string;
  /** Every listed right is required. */
  userRight?: string | string[];
};

export type MenuItem = {
  id: string;
  header: string;
  icon: string;
  links: Link[];
  userRight?: string;
};

// Groups and tools A–Z. Tools every team uses sit together under Tools;
// permissions are per tool and unchanged.
export const sidebarLinks: MenuItem[] = [
  {
    id: "chartering",
    header: "Chartering",
    icon: "bi bi-clipboard-check",
    links: [
      {
        name: "Cargo Orders",
        action: "cargo-orders",
        description: "Open cargo orders",
        userRight: "cargo_orders",
      },
      {
        name: "Cargo Plan",
        action: "cargo-plan",
        description: "Plan cargoes against tonnage",
        userRight: "cargo_plan",
      },
      {
        name: "Signals",
        action: "signals",
        description: "Chartering signals",
      },
    ],
  },
  {
    id: "dataloy",
    header: "Dataloy",
    icon: "bi bi-box-arrow-in-down",
    links: [
      {
        name: "Create Voyage",
        action: "dataloy",
        description: "Set up a new voyage in Dataloy",
      },
    ],
  },
  {
    id: "emissions",
    header: "Emissions",
    icon: "bi bi-thermometer",
    links: [
      {
        name: "EU Reports",
        action: "eu-ets-report",
        description: "EU emissions reporting",
      },
      {
        name: "Voyage CO2",
        action: "emission-report",
        description: "Emissions per voyage",
      },
    ],
  },
  {
    id: "fdtr",
    header: "FDTR",
    icon: "bi bi-infinity",
    userRight: "tradeRecap",
    links: [
      {
        name: "Dashboard",
        action: "ffa-overview",
        description: "FDTR overview",
      },
      {
        name: "Options",
        action: "options",
        description: "Options positions and pricing",
      },
      {
        name: "Seasonality",
        action: "seasonality",
        description: "Seasonal patterns in the market",
      },
    ],
  },
  {
    id: "tools",
    header: "Tools",
    icon: "bi bi-tools",
    links: [
      {
        name: "Business Card",
        action: "business-card",
        description: "Create your business card",
        previously: "Office tools",
        userRight: "businessCard",
      },
      {
        // Open to everyone: Navilex gates editing per fixture, not the page.
        name: "Navilex",
        action: "navilex-v2",
        description: "Contracts and fixtures",
      },
      {
        name: "Port Data",
        action: "ventura-port",
        description: "Port information and history",
        previously: "Ventura",
      },
      {
        name: "Port Weather",
        action: "weather-in-ports",
        description: "Forecasts for the ports you call at",
        previously: "Weather",
      },
      {
        name: "Sea Margin",
        action: "sea-margin",
        description: "Weather allowance for voyage planning",
        previously: "Weather",
      },
      {
        name: "VesselView",
        action: "vessel-view",
        description: "Fleet positions and vessel status",
        previously: "Tonnage",
      },
    ],
  },
  {
    id: "trades",
    header: "Trades",
    icon: "bi bi-currency-dollar",
    userRight: "tradeRecap",
    links: [
      {
        name: "Recap Manager",
        action: "recap-manager",
        description: "Manage fixture recaps",
      },
      {
        name: "Strategies",
        action: "fdtr-strategies",
        description: "Trading strategies",
      },
    ],
  },
  {
    id: "workspace",
    header: "Workspace",
    icon: "bi bi-grid",
    links: [
      {
        name: "API Token",
        action: "token",
        description: "Manage your access token",
        previously: "Admin",
        userRight: ["navilex-admin", "navilex-admin-token"],
      },
      {
        name: "Directory",
        action: "directory",
        description: "Find a colleague",
        previously: "Admin",
        userRight: "navilex-admin",
      },
      {
        name: "Share Files",
        action: "file-sharing",
        description: "Share files with colleagues",
        previously: "File sharing",
        userRight: "file_sharing",
      },
    ],
  },
];
